import React from "react";

export function CardSkeleton() {
  return (
    <div className="skeleton-card">
      <div className="skeleton-header">
        <div className="skeleton-avatar" />
        <div className="skeleton-text-group">
          <div className="skeleton-line skeleton-title" />
          <div className="skeleton-line skeleton-subtitle" />
        </div>
      </div>
      <div className="skeleton-content">
        <div className="skeleton-line" />
        <div className="skeleton-line skeleton-short" />
      </div>
    </div>
  );
}

export function ListSkeleton({ count = 3 }) {
  return (
    <>
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="skeleton-list-item">
          <div className="skeleton-avatar-small" />
          <div className="skeleton-text-group">
            <div className="skeleton-line skeleton-title" />
            <div className="skeleton-line skeleton-subtitle" />
          </div>
        </div>
      ))}
    </>
  );
}

export function StatSkeleton() {
  return (
    <div className="skeleton-stat">
      <div className="skeleton-icon" />
      <div className="skeleton-text-group">
        <div className="skeleton-line skeleton-label" />
        <div className="skeleton-line skeleton-value" />
      </div>
    </div>
  );
}

export default CardSkeleton;
